import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Seo from '../components/seo'
import Layout from '../components/layout'
import Hero from '../components/hero'
import ArticlePreview from '../components/article-preview'

class RootIndex extends React.Component {
  render() {
    const posts = get(this, 'props.data.allContentfulBlogPost.nodes')
    const [author] = get(this, 'props.data.allContentfulPerson.nodes', [])
    const siteUrl = get(this, 'props.data.site.siteMetadata.siteUrl', '')
    const siteName = get(this, 'props.data.site.siteMetadata.siteName', 'レジャーWave！')

    // JSON-LD for WebSite
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteName,
      alternateName: ["レジャーWave", "レジャーウェーブ"],
      url: siteUrl.endsWith('/') ? siteUrl : siteUrl + '/'
    }

    return (
      <Layout location={this.props.location}>
        <Seo pathname="/">
          <link rel="icon" href="/favicon.ico" />
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        </Seo>

        {author && (
          <Hero
            image={author.heroImage.gatsbyImageData}
            title={author.name}
            // content={author.shortBio.shortBio}
          />
        )}

        <ArticlePreview posts={posts} />
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    allContentfulBlogPost(sort: { fields: [publishDate], order: DESC }) {
      nodes {
        title
        slug
        publishDate(formatString: "MMMM Do, YYYY")
        tags
        heroImage {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            width: 424
            height: 212
          )
        }
        description {
          childMarkdownRemark {
            html
          }
        }
      }
    }
    allContentfulPerson(
      filter: { contentful_id: { eq: "15jwOBqpxqSAOy2eOO4S0m" } }
    ) {
      nodes {
        name
        shortBio {
          shortBio
        }
        title
        heroImage: image {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: BLURRED
            width: 1180
          )
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
        siteName
      }
    }
  }
`
